import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from "dayjs";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  name: "base-operation-log",
  mixins: [userPopMixin],
  data: function data() {
    return {
      baseUrl: process.env.VUE_APP_API,
      searchForm: {
        pageNum: 1,
        pageSize: 20
      },
      // 搜索表单

      adminList: [],
      menuList: [],
      buttonList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getAdminList();
            _this.getMenuChildList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    handleChange: function handleChange(value) {
      var _this2 = this;
      this.menuList.forEach(function (item) {
        if (item.id == value[0]) {
          if (value.length == 1) {
            _this2.buttonList = item.operation || [];
          } else {
            item.children.forEach(function (item1) {
              if (item1.id == value[1]) {
                if (value.length == 2) {
                  _this2.buttonList = item1.operation || [];
                } else {
                  item1.children.forEach(function (item2) {
                    if (item2.id == value[2]) {
                      _this2.buttonList = item2.operation || [];
                    }
                  });
                }
              }
            });
          }
        }
      });
      this.getData();
    },
    getMenuChildList: function getMenuChildList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this3.$api.getMenuList();
            case 1:
              res = _context2.v;
              res.data.forEach(function (item) {
                if (item.children.length > 0) {
                  item.children.forEach(function (item1) {
                    if (item1.children.length > 0) {
                      item1.children.forEach(function (item2) {
                        if (item2.children.length == 0) {
                          delete item2.children;
                        }
                      });
                    } else {
                      delete item1.children;
                    }
                  });
                }
              });
              _this3.menuList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getAdminList: function getAdminList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this4.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context3.v;
              _this4.adminList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(page) {
      this.searchForm.pageNum = page;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pageNum = 1;
              }
              _this5.tableLoading = true;
              _context4.n = 1;
              return _this5.$api.getOperationLogList(_this5.searchForm);
            case 1:
              res = _context4.v;
              res.data.content.forEach(function (item) {
                item.createDate = dayjs(item.createDate * 1000).format("YYYY-MM-DD HH:mm");
              });
              _this5.tableData = res.data.content;
              _this5.total = res.data.totalSize;
              _this5.tableLoading = false;
              _this5.getUserListByIds(_this5.tableData, "userId");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};